// Module-level pub/sub bridging the app-level SSE stream to page components.
// The SSE hook (useUploadEventStream) publishes upload-complete events here;
// pages (e.g. GenericCategoryPage) subscribe and reload the affected row.

export interface UploadCompleteDetail {
  // "upload-complete" (phone out-of-band upload) | "extraction-complete" |
  // "extraction-failed" (session 90 async desktop extraction).
  type: string;
  clientId: string;
  sectionId: string;
  rowId: string | null;
  entryId?: string;
  documentId?: string | null;
  // True when the upload staged AI-extracted fields for review (confirmBeforeSaving).
  // The browser opens the review modal and GETs this exact pending extraction.
  hasPending?: boolean;
  pendingId?: string | null;
  // Async extraction job (session 90): the job whose completion/failure this event
  // reports. The client matches it against jobs it is watching.
  jobId?: string;
  filledCount?: number;
  // Cross-section fan-out (session 96): the completed extraction also produced data
  // for sections OTHER than the upload section. The client fetches the job result to
  // surface the fan-out review banner.
  hasFanout?: boolean;
  error?: string;
}

type Listener = (detail: UploadCompleteDetail) => void;

const listeners = new Set<Listener>();

export function subscribeUploadComplete(cb: Listener): () => void {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}

export function publishUploadComplete(detail: UploadCompleteDetail): void {
  listeners.forEach((cb) => {
    try {
      cb(detail);
    } catch {
      /* a listener throwing must not break the others */
    }
  });
}
